<template>

  <div>

    <div class="project-intro">
      <div class="preview">
        <img src="../../assets/portfolio/summit-screens.png" alt="Summit Drilling">
      </div>
      <div class="intro-text">
        <p>
          <a href="https://www.summitdrilling.com/" target="blank">Summit Drilling</a> 
          is a family owned environmental drilling company serving the northeast geography. 
          Always competent in their craft, Summit was looking to differentiate themselves from other 
          drilling companies. After a thorough positioning exercise, the promise of "An Exceptional Experience" 
          and an updated website framed out the new company look.
        </p>
        <p>
          On the website, the employees of the company are featured, stating that they are 
          each "responsible for your experience" which further drives home the promise made 
          to prospects.
        </p>
        <ul>
          <!-- <li>Branding</li> -->
          <!-- <li>UX</li> -->
          <!-- <li>UI</li> -->
          <!-- <li>Product Design</li> -->
          <li>Front-End Development</li>
        </ul>
      </div>
    </div>
    <div class="case-study">
      <div class="browser bar">
        <img src="../../assets/portfolio/summit-1.jpg" alt="Summit Drilling">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/summit-scene-1.jpg" alt="Summit Drilling">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/summit-2.jpg" alt="Summit Drilling">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/summit-3.jpg" alt="Summit Drilling">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/summit-4.jpg" alt="Summit Drilling">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/summit-tablet-and-mobile.jpg" alt="Summit Drilling">
      </div>
    </div>

    <div class="project-outro">
      <div class="outro-text">
        <h2>Easy updates</h2>
        <p>
          The site has a unique look that is fully integrated and custom to 
          the brand. The WordPress platform allows for easy updates to news, equipment, 
          or safety information. The brand and the site are designed to grow with the 
          company, as they continue to deliver on their promise each and every day.
        </p>
        <p style="font-size: 1.3rem; color: grey;">
          Developed while working at <a href="https://asenka.com/" target="blank">Asenka Interactive</a>.
        </p>
      </div>
      <div class="outro-img">
        <img src="../../assets/portfolio/wp-easy-updates.png" alt="wordpress easy updates">
      </div>
    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "summit",
  props: ["title", "subtitle", "hero"]
};
</script>

<style scoped lang="scss">
</style>
